import { PERMISSIONS } from '@/types/access';

// Ordered by how useful the page is as a landing screen. Manage Access has no entry: it
// needs read:vendors too, and any holder of that already lands on the vendor list.
const LANDING_ORDER: ReadonlyArray<readonly [string, string]> = [
  [PERMISSIONS.READ_VENDORS, 'VendorList'],
  [PERMISSIONS.READ_CAPACITY, 'CapacityCalendar'],
  [PERMISSIONS.IMPORT_CAPACITY, 'CapacityImport'],
  [PERMISSIONS.READ_PO, 'CapacityAssignment'],
  // Sidebar order: PO Tracker sits before PO Activity under Operations.
  [PERMISSIONS.READ_PO_TRACKER, 'PoTracker'],
  [PERMISSIONS.READ_PO_ACTIVITY, 'PoActivity'],
  [PERMISSIONS.READ_CUSTOMER_MAPPINGS, 'CustomerMappingList'],
];

/** Route name Home should redirect to, or null when no page this build knows is reachable. */
export function resolveLandingRoute(hasPermission: (permission: string) => boolean): string | null {
  return LANDING_ORDER.find(([permission]) => hasPermission(permission))?.[1] ?? null;
}
